
export type GetChatThreadById200CurrentUserStatusStatus = typeof GetChatThreadById200CurrentUserStatusStatus[keyof typeof GetChatThreadById200CurrentUserStatusStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetChatThreadById200CurrentUserStatusStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  BLOCKED: 'BLOCKED',
} as const;
